module.exports = __webpack_public_path__ + "img/Hypoxia-PRCA_SpatialResearch.51466207.png";